<template>
  <div>
    <el-breadcrumb separator="/" style="margin-bottom: 20px;">
      <el-breadcrumb-item el-breadcrumb-item :to="{ path: '/project/batch' }">项目奖申报批次</el-breadcrumb-item>
      <el-breadcrumb-item el-breadcrumb-item :to="{ path: '/project?batchId=' +  $route.query.batchId }">项目奖申报</el-breadcrumb-item>
      <el-breadcrumb-item>{{ id ? '编辑申报' : '添加申报'}}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-form :model="addForm" v-loading="loadings" :rules="addFormRules" ref="addForm" label-position="top" label-width="120px" class="demo-ruleForms demo-ruleFormss">
        <!-- 一 -->
        <div style="font-weight: 700; font-size: 16px; margin-bottom: 10px;">一、项目基本情况</div>
        <div style="padding-left: 20px; box-sizing: border-box;">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="申报奖项（项目类别）" prop="categoryId">
                <el-cascader size="small" style="width: 100%" v-model="addForm.categoryId" :options="options" :props="optionProps" placeholder="请选择申报奖项（项目类别）" clearable></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="项目名称" prop="projectName">
                <template slot="label"><span>项目名称</span><span style="color: red; font-size: 12px;">（项目名称一旦提交不可修改）</span></template>
                <el-input size="small" maxlength="34" show-word-limit v-model="addForm.projectName" placeholder="请输入项目名称" :disabled="(isDraft == 2 || !isDraft) ? false : true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 所属专业领域 -->
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="所属专业领域" prop="unitNature1">
                <el-radio-group v-model="addForm.unitNature1" style="margin-top: 6px">
                  <el-radio label="1" >公路</el-radio>
                  <el-radio label="2" >铁路</el-radio>
                  <el-radio label="3" >水运</el-radio>
                  <el-radio label="4" >航空</el-radio>
                  <el-radio label="5" >市政</el-radio>
                  <el-radio label="6" >综合交通</el-radio>
                  <el-radio label="8" >邮政</el-radio>
                  <el-radio label="9" >物流</el-radio>
                  <el-radio label="7" >其他</el-radio>
                </el-radio-group>
                <div v-if="addForm.unitNature1 == 7" style="font-size: 14px; margin-right: 10px;">
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-input size="small" maxlength="50" show-word-limit style="width: 100%;" v-model="addForm.nature1Other" placeholder="请输入所属专业领域"></el-input>
                    </el-col>
                  </el-row>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 第一完成单位名称 |||  单位性质   -->
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="第一完成单位名称" prop="mainUnit" >
                <el-input size="small" maxlength="50" show-word-limit v-model="addForm.mainUnit" placeholder="请输入完成单位名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单位性质" prop="unitNature2" >
                <el-select v-model="addForm.unitNature2" placeholder="请选择" size="small" clearable style="width: 100%;">
                  <el-option v-for="(item, index) in unitList" :key="index" :label="item.label" :value="item.id"></el-option>
                </el-select>
                <!-- <el-radio-group v-model="addForm.unitNature2">
                  <el-radio label="1">设计咨询</el-radio>
                  <el-radio label="2">工程施工</el-radio>
                  <el-radio label="3">科研机构</el-radio>
                  <el-radio label="4">高等院校</el-radio>
                  <el-radio label="5">企事业单位</el-radio>
                  <el-radio label="6">项目业主单位</el-radio>
                  <el-radio label="7">其他社会组织</el-radio>
                </el-radio-group> -->
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 其他完成单位 -->
          <div style="color: #606266; margin-top: 10px">其他完成单位（按照贡献度依次填写）</div>
          <div style="padding: 10px 0 10px 20px; box-sizing: border-box; margin-top: 10px; background: #F7F8FA; color: #606266; border-radius: 4px;" v-if="addForm.otherUnit.length > 0">
            <div v-for="(item, index) in addForm.otherUnit" :key="index" style="position: relative;">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="单位名称" :prop="'otherUnit.' + index + '.otherUnit'" :rules="{ required: true, message: '请输入完成单位名称', trigger: 'blur' }">
                    <div style="display: flex;">
                      <el-input size="small" maxlength="50" show-word-limit v-model="item.otherUnit" placeholder="请输入完成单位名称"></el-input>
                      <!-- <el-button style="margin-left: 10px;" type="danger" @click="del('otherUnit', index)">删除</el-button> -->
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <div style="display: flex;">
                    <div style="flex: 1">
                      <el-form-item label="单位性质" :prop="'otherUnit.' + index + '.unitNature2'" :rules="{ required: true, message: '请选择单位性质', trigger: 'change' }">
                        <el-select v-model="item.unitNature2" placeholder="请选择" size="small" clearable style="width: 100%">
                          <el-option v-for="(item, index) in unitList" :key="index" :label="item.label" :value="item.id "></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div style="width: 60px; margin: 0 10px; padding-top: 32px;">
                      <!-- <el-button type="danger" size="small" style="width: 100%" @click="del('otherThose', index)">删除</el-button> -->
                      <el-button type="danger" size="small" style="width: 100%" @click="del('otherUnit', index)">删除</el-button>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <!-- <div style="position: absolute; right: 10px; bottom: 0px">
                <el-button type="danger" size="mini" @click="del('otherUnit', index)">删除</el-button>
              </div> -->
            </div>
          </div>
          <div style="margin: 15px 0;"><el-button type="primary" size="small" icon="el-icon-plus" @click="add('otherUnit')">添加其他完成单位</el-button></div>
          <!-- 第一完成人 联系方式-->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="第一完成人姓名" prop="mainThose">
                <el-input size="small" maxlength="20" show-word-limit v-model="addForm.mainThose" placeholder="请输入完成人姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="第一完成人联系方式" prop="thosePhone">
                <el-input size="small" maxlength="11" show-word-limit v-model="addForm.thosePhone" placeholder="请输入完成人联系方式"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="第一完成人邮箱" prop="email1">
                <el-input size="small" maxlength="30" show-word-limit v-model="addForm.email1" placeholder="请输入完成人邮箱"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="第二完成人姓名" prop="mainThose2">
                <el-input size="small" maxlength="20" show-word-limit v-model="addForm.mainThose2" placeholder="请输入完成人姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="第二完成人联系方式" prop="thosePhone2">
                <el-input size="small" maxlength="11" show-word-limit v-model="addForm.thosePhone2" placeholder="请输入完成人联系方式"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="第二完成人邮箱" prop="email2">
                <el-input size="small" maxlength="30" show-word-limit v-model="addForm.email2" placeholder="请输入完成人邮箱"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="第三完成人姓名" prop="mainThose3">
                <el-input size="small" maxlength="20" show-word-limit v-model="addForm.mainThose3" placeholder="请输入完成人姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="第三完成人联系方式" prop="thosePhone3">
                <el-input size="small" maxlength="11" show-word-limit v-model="addForm.thosePhone3" placeholder="请输入完成人联系方式"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="第三完成人邮箱" prop="email3">
                <el-input size="small" maxlength="30" show-word-limit v-model="addForm.email3" placeholder="请输入完成人邮箱"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 其他完成人 -->
          <div style="color: #606266; margin-top: 10px">其他完成人（按照贡献度依次填写）</div>
          <div v-if="addForm.otherThose.length > 0" style="padding: 10px 0 10px 20px; box-sizing: border-box; margin-top: 10px; background: #F7F8FA; color: #606266; border-radius: 4px;">
            <el-row :gutter="20">
              <el-col :span="7">
                <div v-for="(item, index) in addForm.otherThose" :key="index" >
                  <el-form-item label="完成人姓名" :prop="'otherThose.' + index" :rules="{ required: true, message: '请输入完成人姓名', trigger: 'blur' }">
                    <div style="display: flex;">
                      <el-input size="small" maxlength="20" show-word-limit v-model="addForm.otherThose[index]" placeholder="请输入完成人姓名"></el-input>
                    </div>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="7">
                <div v-for="(item, index) in addForm.phones" :key="index" >
                  <div style="display: flex;">
                    <el-form-item style="flex: 1" label="完成人联系方式" :prop="'phones.' + index" :rules="[{ required: true, message: '请输入完成人联系方式', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '手机号格式错误', trigger: ['blur', 'change'] }]">
                      <div style="display: flex;">
                        <el-input size="small" maxlength="11" show-word-limit v-model="addForm.phones[index]" placeholder="请输入完成人联系方式"></el-input>
                      </div>
                    </el-form-item>
                  </div>
                </div>
              </el-col>
              <el-col :span="10">
                <div v-for="(item, index) in addForm.otherEmails" :key="index" >
                  <div style="display: flex;">
                    <el-form-item style="flex: 1" label="完成人邮箱" :prop="'otherEmails.' + index" :rules="[ { required: true, message: '请输入邮箱地址', trigger: 'blur' }, { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }]">
                      <div style="display: flex;">
                        <el-input size="small" maxlength="30" show-word-limit v-model="addForm.otherEmails[index]" placeholder="请输入完成人邮箱"></el-input>
                      </div>
                    </el-form-item>
                    <div style="width: 60px; margin: 0 10px; padding-top: 32px;">
                      <el-button type="danger" size="small" style="width: 100%" @click="del('otherThose', index)">删除</el-button>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div style="margin: 15px 0;"><el-button type="primary" size="small" icon="el-icon-plus" @click="add('otherThose')">添加其他完成人信息</el-button></div>
        </div>
        <!-- 二 -->
        <div style="font-weight: 700; font-size: 16px; margin: 20px 0 10px;">二、第三方评价情况 <span style="font-weight: 400; font-size: 14px; color: #D9001B">&nbsp;&nbsp;&nbsp;&nbsp; 注：非公开资料（如私人信函等）不能作为评价依据。</span></div>
        <div style="padding-left: 20px; box-sizing: border-box; margin-bottom: 0px;">
          <!-- 1、第三方科技成果鉴定结论（建议省级及以上机构，不超过5个） -->
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="1、第三方科技成果评价结论（建议省级及以上机构，不超过5个）" required>
              </el-form-item>
              <div >
                <div style="padding: 10px; margin-top: 10px; background: #F7F8FA; color: #606266; border-radius: 4px;">
                  <div style="display: flex; margin-bottom: 10px;">
                    <!-- <div style="width: 40px;">序号</div> -->
                    <div style="width: 280px;">评价机构</div>
                    <div style="width: 150px; margin-left: 10px;">评价日期</div>
                    <div style="width: 180px; margin-left: 10px;">评价登记号</div>
                    <div style="flex: 1; margin-left: 10px;">评价结论</div>
                    <div style="width: 60px; margin-left: 10px;"></div>
                  </div>
                  <div v-for="(item, index) in addForm.authConclusions" :key="index" style="display: flex; margin-bottom: 10px">
                    <!-- <div style="width: 40px; line-height: 40px;">{{index + 1}}</div> -->
                    <el-form-item style="width: 280px;" :prop="'authConclusions.' + index + '.orgName'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input size="small" maxlength="300" show-word-limit placeholder="请输入内容" v-model="item.orgName"></el-input>
                    </el-form-item>
                    <el-form-item style="width: 150px; margin-left: 10px;" :prop="'authConclusions.' + index + '.time'" :rules="{ required: true, message: '请选择日期', trigger: 'blur' }">
                      <el-date-picker size="small" style="width: 100%;" v-model="item.time" type="date" value-format="yyyy-MM-dd" placeholder="请选择日期"></el-date-picker>
                    </el-form-item>
                    <!-- 评价登记号 -->
                    <el-form-item style="width: 180px; margin-left: 10px;" :prop="'authConclusions.' + index + '.registerNo'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input size="small" maxlength="300" show-word-limit placeholder="请输入内容" v-model="item.registerNo"></el-input>
                    </el-form-item>
                    <el-form-item style="flex: 1; margin-left: 10px;" :prop="'authConclusions.' + index + '.conclusion'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input
                        maxlength="300"
                        show-word-limit
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 4}"
                        placeholder="请输入内容"
                        v-model="item.conclusion">
                      </el-input>
                    </el-form-item>
                    <div style="width: 60px; margin-left: 10px;">
                      <el-button type="danger" size="small" v-if="index > 0" style="width: 100%" @click="del('authConclusions', index)">删除</el-button>
                    </div>
                  </div>
                </div>
                <div style="margin: 15px 0;">
                  <el-button type="primary" size="small" icon="el-icon-plus" @click="add('authConclusions')">添加</el-button>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- 2、科技查新结论（不超过2个） -->
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="2、科技查新结论（不超过2个）" prop="newConclusionsFlag" >
                <div style="padding-left: 4px;">
                  <el-radio-group v-model="addForm.newConclusionsFlag" style="margin-top: 6px;">
                    <el-radio label="1" >有</el-radio>
                    <el-radio label="2" >无</el-radio>
                  </el-radio-group>
                </div>
              </el-form-item>
              <div v-if="addForm.newConclusionsFlag == 1" >
                <div style="padding: 10px; margin-top: 10px; background: #F7F8FA; color: #606266; border-radius: 4px;">
                  <div style="display: flex; margin-bottom: 10px;">
                    <div style="width: 50px;">序号</div>
                    <div style="width: 280px;">查新机构</div>
                    <div style="width: 150px; margin-left: 10px;">查新日期</div>
                    <div style="flex: 1; margin-left: 10px;">查新结论</div>
                    <div style="width: 60px; margin-left: 10px;"></div>
                  </div>
                  <div v-for="(item, index) in addForm.newConclusions" :key="index" style="display: flex; margin-bottom: 10px">
                    <div style="width: 50px; line-height: 40px;">{{index + 1}}</div>
                    <el-form-item style="width: 280px;" :prop="'newConclusions.' + index + '.orgName'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input size="small" maxlength="300" show-word-limit placeholder="请输入内容" v-model="item.orgName"></el-input>
                    </el-form-item>
                    <el-form-item style="width: 150px; margin-left: 10px;" :prop="'newConclusions.' + index + '.time'" :rules="{ required: true, message: '请选择日期', trigger: 'blur' }">
                      <el-date-picker size="small" style="width: 100%;" v-model="item.time" type="date" value-format="yyyy-MM-dd" placeholder="请选择日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item style="flex: 1; margin-left: 10px;" :prop="'newConclusions.' + index + '.conclusion'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input
                        :autosize="{ minRows: 2, maxRows: 4}"
                        maxlength="300"
                        show-word-limit
                        type="textarea"
                        size="mini"
                        placeholder="请输入内容"
                        v-model="item.conclusion">
                      </el-input>
                    </el-form-item>
                    <div style="width: 60px; margin-left: 10px;">
                      <el-button type="danger" size="small" v-if="index > 0" style="width: 100%" @click="del('newConclusions', index)">删除</el-button>
                    </div>
                  </div>
                </div>
                <div style="margin: 15px 0;">
                  <el-button type="primary" size="small" icon="el-icon-plus" @click="add('newConclusions')">添加</el-button>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- 3、第三方检测结论（检测机构须具有CNAS/CNAL/CMA/MA等检测资质，不超过5个） -->
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="3、第三方检测结论（检测机构须具有CNAS/CNAL/CMA/MA等检测资质，不超过5个）" prop="detectionConclusionsFlag" >
                <div style="padding-left: 4px;">
                  <el-radio-group v-model="addForm.detectionConclusionsFlag" style="margin-top: 6px;">
                    <el-radio label="1" >有</el-radio>
                    <el-radio label="2" >无</el-radio>
                  </el-radio-group>
                </div>
              </el-form-item>
              <div v-if="addForm.detectionConclusionsFlag == 1" >
                <div style="padding: 10px; margin-top: 10px; background: #F7F8FA; color: #606266; border-radius: 4px;">
                  <div style="display: flex; margin-bottom: 10px;">
                    <div style="width: 50px;">序号</div>
                    <div style="width: 280px;">检测机构</div>
                    <div style="width: 150px; margin-left: 10px;">检测日期</div>
                    <div style="flex: 1; margin-left: 10px;">检测结论</div>
                    <div style="width: 60px; margin-left: 10px;"></div>
                  </div>
                  <div v-for="(item, index) in addForm.detectionConclusions" :key="index" style="display: flex; margin-bottom: 10px">
                    <div style="width: 50px; line-height: 40px;">{{index + 1}}</div>
                    <el-form-item style="width: 280px;" :prop="'detectionConclusions.' + index + '.orgName'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input size="small" maxlength="300" show-word-limit placeholder="请输入内容" v-model="item.orgName"></el-input>
                    </el-form-item>
                    <el-form-item style="width: 150px; margin-left: 10px;" :prop="'detectionConclusions.' + index + '.time'" :rules="{ required: true, message: '请选择日期', trigger: 'blur' }">
                      <el-date-picker size="small" style="width: 100%;" v-model="item.time" type="date" value-format="yyyy-MM-dd" placeholder="请选择日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item style="flex: 1; margin-left: 10px;" :prop="'detectionConclusions.' + index + '.conclusion'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input
                        :autosize="{ minRows: 2, maxRows: 4}"
                        maxlength="300"
                        show-word-limit
                        type="textarea"
                        size="mini"
                        placeholder="请输入内容"
                        v-model="item.conclusion">
                      </el-input>
                    </el-form-item>
                    <div style="width: 60px; margin-left: 10px;">
                      <el-button type="danger" size="small" v-if="index > 0" style="width: 100%" @click="del('detectionConclusions', index)">删除</el-button>
                    </div>
                  </div>
                </div>
                <div style="margin: 15px 0;">
                  <el-button type="primary" size="small" icon="el-icon-plus" @click="add('detectionConclusions')">添加</el-button>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- 4、国内外同行在重要学术刊物（专著）和重要国际学术会议等公开发表的学术性评价意见（不超过5个） -->
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="4、国内外同行在重要学术刊物（专著）和重要国际学术会议等公开发表的学术性评价意见（不超过5个）" prop="academicOpinionsFlag" >
                <div style="padding-left: 4px;">
                  <el-radio-group v-model="addForm.academicOpinionsFlag" style="margin-top: 6px;">
                    <el-radio label="1" >有</el-radio>
                    <el-radio label="2" >无</el-radio>
                  </el-radio-group>
                </div>
              </el-form-item>
              <div v-if="addForm.academicOpinionsFlag == 1" >
                <div style="padding: 10px; margin-top: 10px; background: #F7F8FA; color: #606266; border-radius: 4px;">
                  <div style="display: flex; margin-bottom: 10px;">
                    <div style="width: 50px;">序号</div>
                    <div style="width: 280px;">刊物/专著/会议名称</div>
                    <div style="width: 150px; margin-left: 10px;">发表/出版/举办年月</div>
                    <div style="flex: 1; margin-left: 10px;">评价意见</div>
                    <div style="width: 60px; margin-left: 10px;"></div>
                  </div>
                  <div v-for="(item, index) in addForm.academicOpinions" :key="index" style="display: flex; margin-bottom: 10px">
                    <div style="width: 50px; line-height: 40px;">{{index + 1}}</div>
                    <el-form-item style="width: 280px;" :prop="'academicOpinions.' + index + '.name'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input size="small" maxlength="300" show-word-limit placeholder="请输入内容" v-model="item.name"></el-input>
                    </el-form-item>
                    <el-form-item style="width: 150px; margin-left: 10px;" :prop="'academicOpinions.' + index + '.time'" :rules="{ required: true, message: '请选择日期', trigger: 'blur' }">
                      <el-date-picker size="small" style="width: 100%;" v-model="item.time" type="date" value-format="yyyy-MM-dd" placeholder="请选择日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item style="flex: 1; margin-left: 10px;" :prop="'academicOpinions.' + index + '.opinion'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input
                        :autosize="{ minRows: 2, maxRows: 4}"
                        maxlength="300"
                        show-word-limit
                        type="textarea"
                        size="mini"
                        placeholder="请输入内容"
                        v-model="item.opinion">
                      </el-input>
                    </el-form-item>
                    <div style="width: 60px; margin-left: 10px;">
                      <el-button type="danger" size="small" v-if="index > 0" style="width: 100%" @click="del('academicOpinions', index)">删除</el-button>
                    </div>
                  </div>
                </div>
                <div style="margin: 15px 0;">
                  <el-button type="primary" size="small" icon="el-icon-plus" @click="add('academicOpinions')">添加</el-button>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- 5、具有影响力的新闻媒体评价（不超过5个） -->
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="5、具有影响力的新闻媒体评价（不超过5个）" prop="mediaEvaluationsFlag" >
                <div style="padding-left: 4px;">
                  <el-radio-group v-model="addForm.mediaEvaluationsFlag" style="margin-top: 6px;">
                    <el-radio label="1" >有</el-radio>
                    <el-radio label="2" >无</el-radio>
                  </el-radio-group>
                </div>
              </el-form-item>
              <div v-if="addForm.mediaEvaluationsFlag == 1" >
                <div style="padding: 10px; margin-top: 10px; background: #F7F8FA; color: #606266; border-radius: 4px;">
                  <div style="display: flex; margin-bottom: 10px;">
                    <div style="width: 50px;">序号</div>
                    <div style="width: 280px;">媒体名称</div>
                    <div style="width: 150px; margin-left: 10px;">出版日期</div>
                    <div style="width: 150px; margin-left: 10px;">版面</div>
                    <div style="flex: 1; margin-left: 10px;">评价意见</div>
                    <div style="width: 60px; margin-left: 10px;"></div>
                  </div>
                  <div v-for="(item, index) in addForm.mediaEvaluations" :key="index" style="display: flex; margin-bottom: 10px">
                    <div style="width: 50px; line-height: 40px;">{{index + 1}}</div>
                    <el-form-item style="width: 280px;" :prop="'mediaEvaluations.' + index + '.mediaName'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input size="small" maxlength="300" show-word-limit placeholder="请输入内容" v-model="item.mediaName"></el-input>
                    </el-form-item>
                    <el-form-item style="width: 150px; margin-left: 10px;" :prop="'mediaEvaluations.' + index + '.publishTime'" :rules="{ required: true, message: '请选择日期', trigger: 'blur' }">
                      <el-date-picker size="small" style="width: 100%;" v-model="item.publishTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item style="width: 150px; margin-left: 10px;" :prop="'mediaEvaluations.' + index + '.layout'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input size="small" maxlength="300" show-word-limit placeholder="请输入内容" v-model="item.layout"></el-input>
                    </el-form-item>
                    <el-form-item style="flex: 1; margin-left: 10px;" :prop="'mediaEvaluations.' + index + '.evaluation'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input
                        :autosize="{ minRows: 2, maxRows: 4}"
                        maxlength="300"
                        show-word-limit
                        type="textarea"
                        size="mini"
                        placeholder="请输入内容"
                        v-model="item.evaluation">
                      </el-input>
                    </el-form-item>
                    <div style="width: 60px; margin-left: 10px;">
                      <el-button type="danger" size="small" v-if="index > 0" style="width: 100%" @click="del('mediaEvaluations', index)">删除</el-button>
                    </div>
                  </div>
                </div>
                <div style="margin: 15px 0 0;">
                  <el-button type="primary" size="small" icon="el-icon-plus" @click="add('mediaEvaluations')">添加</el-button>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <!-- 三 -->
        <div style="font-weight: 700; font-size: 16px; margin: 20px 0 10px;">三、应用推广情况</div>
        <div style="padding-left: 20px; box-sizing: border-box; margin-bottom: 0px;">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="应用推广情况 （不超过10个）" prop="appExtendsFlag" >
                <div style="padding-left: 4px;">
                  <el-radio-group v-model="addForm.appExtendsFlag" style="margin-top: 6px;">
                    <el-radio label="1" >有</el-radio>
                    <el-radio label="2" >无</el-radio>
                  </el-radio-group>
                </div>
              </el-form-item>
              <div v-if="addForm.appExtendsFlag == 1" >
                <div style="padding: 10px; margin-top: 10px; background: #F7F8FA; color: #606266; border-radius: 4px;">
                  <div style="display: flex; margin-bottom: 10px;">
                    <div style="width: 50px;">序号</div>
                    <div style="width: 280px;">应用机构</div>
                    <div style="width: 150px; margin-left: 10px;">应用起始时间</div>
                    <div style="width: 150px; margin-left: 10px;">联系人</div>
                    <div style="flex: 1; margin-left: 10px;">联系电话</div>
                    <div style="width: 60px; margin-left: 10px;"></div>
                  </div>
                  <div v-for="(item, index) in addForm.appExtends" :key="index" style="display: flex; margin-bottom: 10px">
                    <div style="width: 50px; line-height: 40px;">{{index + 1}}</div>
                    <el-form-item style="width: 280px;" :prop="'appExtends.' + index + '.unitOrgName'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input size="small" maxlength="300" show-word-limit placeholder="请输入内容" v-model="item.unitOrgName"></el-input>
                    </el-form-item>
                    <el-form-item style="width: 150px; margin-left: 10px;" :prop="'appExtends.' + index + '.appStartTime'" :rules="{ required: true, message: '请选择日期', trigger: 'blur' }">
                      <el-date-picker size="small" style="width: 100%;" v-model="item.appStartTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item style="width: 150px; margin-left: 10px;" :prop="'appExtends.' + index + '.contactPersonName'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input size="small" maxlength="300" show-word-limit placeholder="请输入内容" v-model="item.contactPersonName"></el-input>
                    </el-form-item>
                    <el-form-item style="flex: 1; margin-left: 10px;" :prop="'appExtends.' + index + '.contactPersonPhone'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input size="small" maxlength="50" show-word-limit placeholder="请输入内容" v-model="item.contactPersonPhone"></el-input>
                    </el-form-item>
                    <div style="width: 60px; margin-left: 10px;">
                      <el-button type="danger" size="small" v-if="index > 0" style="width: 100%" @click="del('appExtends', index)">删除</el-button>
                    </div>
                  </div>
                </div>
                <div style="margin: 15px 0 0;">
                  <el-button type="primary" size="small" icon="el-icon-plus" @click="add('appExtends')">添加</el-button>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <!-- 四 -->
        <div style="font-weight: 700; font-size: 16px; margin: 20px 0 10px;">四、曾获科技奖励情况</div>
        <div style="padding-left: 20px; box-sizing: border-box; margin-bottom: 0px;">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="曾获科技奖励情况 （不超过10个）" prop="historyRewardsFlag" >
                <div style="padding-left: 4px;">
                  <el-radio-group v-model="addForm.historyRewardsFlag" style="margin-top: 6px;">
                    <el-radio label="1" >有</el-radio>
                    <el-radio label="2" >无</el-radio>
                  </el-radio-group>
                </div>
              </el-form-item>
              <div v-if="addForm.historyRewardsFlag == 1" >
                <div v-for="(item, index) in addForm.historyRewards" :key="index" style="padding: 10px; margin-top: 10px; background: #F7F8FA; color: #606266; border-radius: 4px;">
                  <div style="display: flex; ">
                    <el-form-item label="序号" style="width: 40px;">
                      <div >{{index + 1}}</div>
                    </el-form-item>
                    <el-form-item style="width: 150px; margin-left: 10px;" label="获奖时间" :prop="'historyRewards.' + index + '.time'" :rules="{ required: true, message: '请选择日期', trigger: 'change' }">
                      <el-date-picker size="small" style="width: 100%;" v-model="item.time" type="date" value-format="yyyy-MM-dd" placeholder="请选择日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item style="width: 220px; margin-left: 10px;" label="奖项名称" :prop="'historyRewards.' + index + '.name'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input size="small" maxlength="300" show-word-limit placeholder="请输入内容" v-model="item.name"></el-input>
                    </el-form-item>
                    <el-form-item style="width: 220px; margin-left: 10px;" label="奖励等级" :prop="'historyRewards.' + index + '.lv'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input size="small" maxlength="300" show-word-limit placeholder="请输入内容" v-model="item.lv"></el-input>
                    </el-form-item>
                    <el-form-item style="flex: 1; margin-left: 10px;" label="授奖部门（机构）" :prop="'historyRewards.' + index + '.section'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input size="small" maxlength="300" show-word-limit placeholder="请输入内容" v-model="item.section"></el-input>
                    </el-form-item>
                  </div>
                  <div style="padding-left: 50px;">
                    <el-form-item label="主要完成单位（按顺序完整填写）" :prop="'historyRewards.' + index + '.completionUnit'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input
                        :autosize="{ minRows: 2, maxRows: 4}"
                        maxlength="500"
                        show-word-limit
                        type="textarea"
                        size="mini"
                        placeholder="请输入内容(单位之间用，隔开)"
                        v-model="item.completionUnit">
                      </el-input>
                    </el-form-item>
                    <el-form-item label="主要获奖人（按顺序完整填写）" :prop="'historyRewards.' + index + '.people'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input
                      :autosize="{ minRows: 2, maxRows: 4}"
                        maxlength="100"
                        show-word-limit
                        type="textarea"
                        size="mini"
                        placeholder="请输入内容"
                        v-model="item.people">
                      </el-input>
                    </el-form-item>
                  </div>
                  <div style="text-align: right;">
                    <el-button type="danger" size="mini" v-if="index > 0" @click="del('historyRewards', index)">删除</el-button>
                  </div>
                </div>
                <div style="margin: 15px 0 0;"><el-button type="primary" size="small" icon="el-icon-plus" @click="add('historyRewards')">添加</el-button></div>
              </div>
            </el-col>
          </el-row>
        </div>
        <!-- 五 -->
        <div style="font-weight: 700; font-size: 16px; margin: 20px 0 10px;">五、主要知识产权目录情况</div>
        <div style="padding-left: 20px; box-sizing: border-box; margin-bottom: 0px;">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="主要知识产权 （不超过20项）" prop="intellectualPropertiesFlag" >
                <div style="padding-left: 4px;">
                  <el-radio-group v-model="addForm.intellectualPropertiesFlag" style="margin-top: 6px;">
                    <el-radio label="1" >有</el-radio>
                    <el-radio label="2" >无</el-radio>
                  </el-radio-group>
                </div>
              </el-form-item>
              <div v-if="addForm.intellectualPropertiesFlag == 1" >
                <div v-for="(item, index) in addForm.intellectualProperties" :key="index" style="padding: 10px; margin-top: 10px; background: #F7F8FA; color: #606266; border-radius: 4px;">
                  <div style="display: flex; ">
                    <el-form-item label="序号" style="width: 40px;">
                      <div >{{index + 1}}</div>
                    </el-form-item>
                    <el-form-item style="width: 130px; margin-left: 10px;" label="知识产权类别" :prop="'intellectualProperties.' + index + '.type'" :rules="{ required: true, message: '请选择', trigger: 'change' }">
                      <!-- <el-input size="small" maxlength="50" show-word-limit placeholder="请输入内容" v-model="item.type"></el-input> -->
                      <el-select v-model="item.type" placeholder="请选择" style="width: 100%;" clearable size="small">
                        <el-option v-for="(el, i) in zscqArr" :key="i" :label="el.label" :value="el.label"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item style="width: 150px; margin-left: 10px;" label="知识产权名称" :prop="'intellectualProperties.' + index + '.name'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input size="small" maxlength="300" show-word-limit placeholder="请输入内容" v-model="item.name"></el-input>
                    </el-form-item>
                    <el-form-item style="width: 150px; margin-left: 10px;" label="国家（地区）" :prop="'intellectualProperties.' + index + '.nation'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input size="small" maxlength="300" show-word-limit placeholder="请输入内容" v-model="item.nation"></el-input>
                    </el-form-item>
                    <el-form-item style="width: 150px; margin-left: 10px;" label="授权号" :prop="'intellectualProperties.' + index + '.accreditNo'" :rules="[
                    { required: true, message: '请输入内容', trigger: 'blur' },
                    { pattern: /^[^!#$%^&*()=+,._\-: /?';<>》《|\\“”]*$/, message: '不能输入标点符号和空格', trigger: ['blur', 'change'] }
                    ]">
                      <el-input size="small" maxlength="300" show-word-limit placeholder="请输入内容" v-model="item.accreditNo"></el-input>
                    </el-form-item>
                    <el-form-item style="width: 150px; margin-left: 10px;" label="授权日期" :prop="'intellectualProperties.' + index + '.accreditTime'" :rules="{ required: true, message: '请选择日期', trigger: 'change' }">
                      <el-date-picker size="small" style="width: 100%;" v-model="item.accreditTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item style="flex: 1; margin-left: 10px;" label="证书编号" :prop="'intellectualProperties.' + index + '.certificateNo'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input size="small" maxlength="300" show-word-limit placeholder="请输入内容" v-model="item.certificateNo"></el-input>
                    </el-form-item>
                  </div>
                  <div style="padding-left: 44px;">
                    <el-form-item label="权利人（前3名，按单位顺序完整填写）" required style="margin-bottom: 0;"></el-form-item>
                    <div style="display: flex;">
                      <el-form-item style="flex: 1; " :prop="'intellectualProperties.' + index + '.obligeeFirstPlace'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                        <el-input size="small" placeholder="请输入内容" v-model="item.obligeeFirstPlace" maxlength="50" show-word-limit></el-input>
                      </el-form-item>
                      <el-form-item style="flex: 1; margin-left: 10px;" >
                        <el-input size="small" placeholder="请输入内容" v-model="item.obligeeRunnerUp" maxlength="50" show-word-limit></el-input>
                      </el-form-item>
                      <el-form-item style="flex: 1; margin-left: 10px;" >
                        <el-input size="small" placeholder="请输入内容" v-model="item.obligeeThirdPlace" maxlength="50" show-word-limit></el-input>
                      </el-form-item>
                    </div>
                    <el-form-item label="发明人（前3名，按署名顺序完整填写）" required style="margin-bottom: 0;"></el-form-item>
                    <div style="display: flex;">
                      <el-form-item style="flex: 1; " :prop="'intellectualProperties.' + index + '.inventorFirstPlace'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                        <el-input size="small" maxlength="50" show-word-limit placeholder="请输入内容" v-model="item.inventorFirstPlace"></el-input>
                      </el-form-item>
                      <el-form-item style="flex: 1; margin-left: 10px;" >
                        <el-input size="small" maxlength="50" show-word-limit placeholder="请输入内容" v-model="item.inventorRunnerUp"></el-input>
                      </el-form-item>
                      <el-form-item style="flex: 1; margin-left: 10px;" >
                        <el-input size="small" maxlength="50" show-word-limit placeholder="请输入内容" v-model="item.inventorThirdPlace"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div style="text-align: right;">
                    <el-button type="danger" size="small" v-if="index > 0" @click="del('intellectualProperties', index)">删除</el-button>
                  </div>
                </div>
                <div style="margin: 15px 0 0;"><el-button type="primary" size="small" icon="el-icon-plus" @click="add('intellectualProperties')">添加</el-button></div>
              </div>
            </el-col>
          </el-row>
        </div>
        <!-- 六 -->
        <div style="font-weight: 700; font-size: 16px; margin: 20px 0 10px;">六、主持或参与制定的标准情况</div>
        <div style="padding-left: 20px; box-sizing: border-box; margin-bottom: 0px;">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="主持或参与制定的标准（包括国际标准、国家标准、行业标准、地方标准和团体标准，不超过5项）" prop="formulateStandardsFlag" >
                <div style="padding-left: 4px;">
                  <el-radio-group v-model="addForm.formulateStandardsFlag" style="margin-top: 6px;">
                    <el-radio label="1" >有</el-radio>
                    <el-radio label="2" >无</el-radio>
                  </el-radio-group>
                </div>
              </el-form-item>
              <div v-if="addForm.formulateStandardsFlag == 1" >
                <div style="padding: 10px; margin-top: 10px; background: #F7F8FA; color: #606266; border-radius: 4px;">
                  <div style="display: flex; margin-bottom: 10px;">
                    <div style="width: 50px;">序号</div>
                    <div style="width: 150px;">标准类型</div>
                    <div style="width: 150px; margin-left: 10px;">标准名称</div>
                    <div style="width: 150px; margin-left: 10px;">标准号</div>
                    <div style="width: 150px; margin-left: 10px;">发布时间</div>
                    <div style="flex: 1; margin-left: 10px;">发布机关</div>
                    <div style="width: 60px; margin-left: 10px;"></div>
                  </div>
                  <div v-for="(item, index) in addForm.formulateStandards" :key="index" style="display: flex; margin-bottom: 10px">
                    <div style="width: 50px; line-height: 40px;">{{index + 1}}</div>
                    <el-form-item style="width: 150px;" :prop="'formulateStandards.' + index + '.type'" :rules="{ required: true, message: '请选择', trigger: 'blur' }">
                      <!-- <el-input size="small" maxlength="50" show-word-limit placeholder="请输入内容" v-model="item.type"></el-input> -->
                      <el-select v-model="item.type" placeholder="请选择" style="width: 100%;" clearable size="small">
                        <el-option v-for="(el, i) in rzArr" :key="i" :label="el.label" :value="el.label"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item style="width: 150px;margin-left: 10px;" :prop="'formulateStandards.' + index + '.name'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input size="small" maxlength="300" show-word-limit placeholder="请输入内容" v-model="item.name"></el-input>
                    </el-form-item>
                    <el-form-item style="width: 150px;margin-left: 10px;" :prop="'formulateStandards.' + index + '.no'" :rules="[
                    { required: true, message: '请输入内容', trigger: 'blur' },
                    { pattern: /^[^!#$%^&*()=+,._\-: /?';<>》《|\\“”]*$/, message: '不能输入标点符号和空格', trigger: ['blur', 'change'] }
                    ]">
                      <el-input size="small" maxlength="300" show-word-limit placeholder="请输入内容" v-model="item.no"></el-input>
                    </el-form-item>
                    <el-form-item style="width: 150px; margin-left: 10px;" :prop="'formulateStandards.' + index + '.publishTime'" :rules="{ required: true, message: '请选择日期', trigger: 'blur' }">
                      <el-date-picker size="small" style="width: 100%;" v-model="item.publishTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item style="flex: 1; margin-left: 10px;" :prop="'formulateStandards.' + index + '.publishOrgName'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input size="small" maxlength="300" show-word-limit placeholder="请输入内容" v-model="item.publishOrgName"></el-input>
                    </el-form-item>
                    <div style="width: 60px; margin-left: 10px;">
                      <el-button type="danger" size="small" v-if="index > 0" style="width: 100%" @click="del('formulateStandards', index)">删除</el-button>
                    </div>
                  </div>
                </div>
                <div style="margin: 15px 0 0;">
                  <el-button type="primary" size="small" icon="el-icon-plus" @click="add('formulateStandards')">添加</el-button>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <!-- 七 -->
        <div style="font-weight: 700; font-size: 16px; margin: 20px 0 10px;">七、代表性论文/专著发表情况</div>
        <div style="padding-left: 20px; box-sizing: border-box; margin-bottom: 0px;">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="代表性论文/专著发表情况 （不超过10篇/部）" prop="monographsFlag" >
                <div style="padding-left: 4px;">
                  <el-radio-group v-model="addForm.monographsFlag" style="margin-top: 6px;">
                    <el-radio label="1" >有</el-radio>
                    <el-radio label="2" >无</el-radio>
                  </el-radio-group>
                </div>
              </el-form-item>
              <div v-if="addForm.monographsFlag == 1" >
                <div v-for="(item, index) in addForm.monographs" :key="index" style="padding: 10px; margin-top: 10px; background: #F7F8FA; color: #606266; border-radius: 4px;">
                  <div style="display: flex; ">
                    <el-form-item label="序号" style="width: 40px;">
                      <div >{{index + 1}}</div>
                    </el-form-item>
                    <el-form-item style="flex: 1; margin-left: 10px;" label="论文/专著名称" :prop="'monographs.' + index + '.name'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input size="small" maxlength="500" show-word-limit placeholder="请输入内容" v-model="item.name"></el-input>
                    </el-form-item>
                    <el-form-item style="width: 220px; margin-left: 10px;" label="刊名/出版社" :prop="'monographs.' + index + '.publishingHouse'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input size="small" maxlength="300" show-word-limit placeholder="请输入内容" v-model="item.publishingHouse"></el-input>
                    </el-form-item>
                    <el-form-item style="width: 150px; margin-left: 10px;" label="发表/出版年月" :prop="'monographs.' + index + '.publishTime'" :rules="{ required: true, message: '请选择日期', trigger: 'change' }">
                      <el-date-picker size="small" style="width: 100%;" v-model="item.publishTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item style="width: 150px; margin-left: 10px;" label="年（卷）：页码" :prop="'monographs.' + index + '.location'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                      <el-input size="small" maxlength="50" show-word-limit placeholder="请输入内容" v-model="item.location"></el-input>
                    </el-form-item>
                  </div>
                  <div style="padding-left: 50px;">
                    <el-form-item label="作者（前3名，按署名顺序完整填写）" required style="margin-bottom: 0;" ></el-form-item>
                    <div style="display: flex;">
                      <el-form-item style="flex: 1; " :prop="'monographs.' + index + '.authorFirstPlace'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                        <el-input size="small" maxlength="50" show-word-limit placeholder="请输入内容" v-model="item.authorFirstPlace"></el-input>
                      </el-form-item>
                      <el-form-item style="flex: 1; margin-left: 10px;" :prop="'monographs.' + index + '.authorRunnerUp'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                        <el-input size="small" maxlength="50" show-word-limit placeholder="请输入内容" v-model="item.authorRunnerUp"></el-input>
                      </el-form-item>
                      <el-form-item style="flex: 1; margin-left: 10px;" :prop="'monographs.' + index + '.authorThirdPlace'" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
                        <el-input size="small" maxlength="50" show-word-limit placeholder="请输入内容" v-model="item.authorThirdPlace"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div style="text-align: right;">
                    <el-button type="danger" size="small" v-if="index > 0" @click="del('monographs', index)">删除</el-button>
                  </div>
                </div>
                <div style="margin: 15px 0 0;"><el-button type="primary" size="small" icon="el-icon-plus" @click="add('monographs')">添加</el-button></div>
              </div>
            </el-col>
          </el-row>
        </div>
        <!-- 八 -->
        <div style="font-weight: 700; font-size: 16px; margin: 20px 0 10px;">八、项目来源情况</div>
        <div style="padding-left: 20px; box-sizing: border-box; margin-bottom: 20px;">
          <el-row :gutter="20">
            <el-col :span="24">
              <div style="background: #FEF5E6; padding: 10px 5px; margin: 0 0 10px; border-radius: 4px; line-height: 22px;">
                <div style="display: flex;">
                  <div style="text-align: right; width: 150px; font-weight: 700;">国家级科技项目类型：</div>
                  <div style="flex: 1">1.国家自然科学基金；2.国家科技重大专项；3.国家重点研发计划；4.技术创新引导专项（基金）；5.基地和人才专项；</div>
                </div>
                <div style="display: flex;">
                  <div style="text-align: right; width: 150px; font-weight: 700;">省部级科技项目类型：</div>
                  <div style="flex: 1">1.部级基金；2.省级科技专项资金；3.市、厅级项目，部分单位科技专项资金项目；</div>
                </div>
                <div style="display: flex;">
                  <div style="text-align: right; width: 150px; font-weight: 700;">其他主体科技项目：</div>
                  <div style="flex: 1">高校、企业、科研机构、行业学协会等单位独立自研项目；</div>
                </div>
              </div>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="项目来源" >
                    <el-select v-model="addForm.projectSource" placeholder="请选择" size="small" clearable style="width: 100%">
                      <el-option label="国家级科技项目类型" value="国家级科技项目类型"></el-option>
                      <el-option label="省部级科技项目类型" value="省部级科技项目类型"></el-option>
                      <el-option label="其他主体科技项目" value="其他主体科技项目"></el-option>
                    </el-select>
                    <!-- <el-input size="small" maxlength="50" show-word-limit v-model="addForm.projectSource" placeholder="请输入项目来源"></el-input> -->
                    <!-- <el-radio-group v-model="addForm.projectSource" style="margin-top: 6px;">
                      <el-radio label="国家级科技项目类型" border size="small">国家级科技项目类型</el-radio>
                      <el-radio label="省部级科技项目类型" border size="small">省部级科技项目类型</el-radio>
                      <el-radio label="其他主体科技项目" border size="small">其他主体科技项目</el-radio>
                    </el-radio-group> -->
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="领导人圈阅批示次数">
                <el-input size="small" v-model="addForm.viewedTimes" type="number" placeholder="请输入数量"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="有关政策文件制定被采用次数">
                <el-input size="small" type="number" v-model="addForm.policyUseTimes" placeholder="请输入数量"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 九 -->
        <div style="font-weight: 700; font-size: 16px; margin: 20px 0 10px;">九、项目数据</div>
        <div style="padding-left: 20px; box-sizing: border-box; margin-bottom: 20px;">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="工程应用数(个)" prop="proveUnitNumber">
                <el-input size="small" v-model="addForm.proveUnitNumber" placeholder="请输入数量" maxlength="20"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="专利发明数(个)" prop="patentNumber">
                <el-input size="small" v-model.trim="addForm.patentNumber" placeholder="请输入数量" maxlength="20"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="实用专利数(个)" prop="newPatentNumber">
                <el-input size="small" v-model.trim="addForm.newPatentNumber" placeholder="请输入数量" maxlength="20"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="软件著作权数(个)" prop="softwareCopyrightNumber">
                <el-input size="small" v-model.trim="addForm.softwareCopyrightNumber" placeholder="请输入数量" maxlength="20"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="论文数(个)（论文总数=SCI+SSC+CSSCI+ei）" prop="thesisNumber">
                <el-input size="small" v-model.trim="addForm.thesisNumber" placeholder="请输入数量" maxlength="20"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="SCI(篇)" prop="sciNumber">
                <el-input size="small" v-model.trim="addForm.sciNumber" placeholder="请输入数量" maxlength="20"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="SSCI(篇)" prop="ssciNumber">
                <el-input size="small" v-model.trim="addForm.ssciNumber" placeholder="请输入数量" maxlength="20"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="CSSCI(篇)" prop="cssciNumber">
                <el-input size="small" v-model.trim="addForm.cssciNumber" placeholder="请输入数量" maxlength="20"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="ei(篇)" prop="eiNumber">
                <el-input size="small" v-model.trim="addForm.eiNumber" placeholder="请输入数量" maxlength="20"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="著作数(个)" prop="methodNumber">
                <el-input size="small" v-model.trim="addForm.methodNumber" placeholder="请输入数量" maxlength="20"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="获奖数(个)" prop="awardNumber">
                <el-input size="small" v-model.trim="addForm.awardNumber" placeholder="请输入数量" maxlength="20"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="研究报告摘要" prop="isResearBg">
                <el-input
                :autosize="{ minRows: 2, maxRows: 4}"
                maxlength="200"
                show-word-limit
                type="textarea"
                size="mini"
                placeholder="请输入内容"
                v-model="addForm.isResearBg">
              </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 十 -->
        <div style="font-weight: 700; font-size: 16px; margin: 20px 0 10px;">十、附件上传</div>
        <div style="padding-left: 20px; box-sizing: border-box; margin-bottom: 20px;">
          <!-- 1 -->
          <el-row :gutter="20" style="margin-bottom: 20px;">
            <el-col :span="12">
              <el-form-item label="1、请提交申报书（限doc/docx格式文件 30MB）" prop="declarationFilePath" class="db-lable-b">
                <el-checkbox-group v-model="addForm.declarationFilePath" v-show="false"></el-checkbox-group>
                <My-Upload-Filebutton :limit="1" :size="30" :accept="'.doc,.docx'" @UploadFileFun="UploadFileFun($event, 'declarationFilePath')" :callbackShow="addForm.declarationFiles"></My-Upload-Filebutton>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="2、第三方评价（科技成果评价证明、科技查新报告、第三方检测结论、国内外同行在重要学术刊物（专著）和重要国际学术会议等公开发表的学术性评价意见、具有影响力的新闻媒体评价 限pdf格式文件 100MB）" prop="evaluationFilePath" class="db-lable-b">
                <el-checkbox-group v-model="addForm.evaluationFilePath" v-show="false"></el-checkbox-group>
                <My-Upload-Filebutton :limit="1" :size="100" :accept="'.pdf'" @UploadFileFun="UploadFileFun($event, 'evaluationFilePath')" :callbackShow="addForm.evaluationFiles"></My-Upload-Filebutton>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 2 -->
          <el-row :gutter="20" style="margin-bottom: 20px;">
            <el-col :span="12">
              <el-form-item label="3、应用推广相关证明（限pdf格式文件 30MB）" class="db-lable-b">
                <My-Upload-Filebutton :limit="1" :size="30" :accept="'.pdf'" @UploadFileFun="UploadFileFun($event, 'extensionCertificateFilePath')" :callbackShow="addForm.extensionCertificateFiles"></My-Upload-Filebutton>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="4、本项目曾获科技奖励相关证明（限pdf格式文件 30MB）" class="db-lable-b">
                <My-Upload-Filebutton :limit="1" :size="30" :accept="'.pdf'" @UploadFileFun="UploadFileFun($event, 'historyRewardsFilePath')" :callbackShow="addForm.historyRewardsFiles"></My-Upload-Filebutton>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 3 -->
          <el-row :gutter="20" style="margin-bottom: 20px;">
            <el-col :span="12">
              <el-form-item label="5、知识产权证明（发明专利、实用新型专利、软件著作权、著作、论文等。著作及论文选取代表性，不超过10个 限pdf格式文件 50MB）" class="db-lable-b">
                <My-Upload-Filebutton :limit="1" :size="50" :accept="'.pdf'" @UploadFileFun="UploadFileFun($event, 'titleCertificateFilePath')" :callbackShow="addForm.titleCertificateFiles"></My-Upload-Filebutton>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="6、研究报告（不超过200页 限pdf格式文件 30MB）" prop="researchReportFilePath" class="db-lable-b">
                <el-checkbox-group v-model="addForm.researchReportFilePath" v-show="false"></el-checkbox-group>
                <My-Upload-Filebutton :limit="1" :size="30" :accept="'.pdf'" @UploadFileFun="UploadFileFun($event, 'researchReportFilePath')" :callbackShow="addForm.researchReportFiles"></My-Upload-Filebutton>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 4 -->
          <el-row :gutter="20" style="margin-bottom: 20px;">
            <el-col :span="12">
              <el-form-item label="7、软课题研究项目需要提供：项目来源、社会效益、项目是否被有关领导签阅或被政府有关部门实际应用（限pdf格式文件 30MB）" prop="" class="db-lable-b">
                <My-Upload-Filebutton :limit="1" :size="30" :accept="'.pdf'" @UploadFileFun="UploadFileFun($event, 'softProjectFilePath')" :callbackShow="addForm.softProjectFiles"></My-Upload-Filebutton>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="8、其他证明等（限pdf格式文件 30MB）" prop="" class="db-lable-b">
                <My-Upload-Filebutton :limit="1" :size="30" :accept="'.pdf'" @UploadFileFun="UploadFileFun($event, 'otherProofFilePath')" :callbackShow="addForm.otherProofFiles"></My-Upload-Filebutton>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20" style="margin-bottom: 20px;">
            <el-col :span="12">
              <el-form-item label="9、主持或参与制定的标准文件（限pdf格式文件 100MB）" prop="" class="db-lable-b">
                <My-Upload-Filebutton :limit="1" :size="100" :accept="'.pdf'" @UploadFileFun="UploadFileFun($event, 'presideFilePath')" :callbackShow="addForm.presideFiles"></My-Upload-Filebutton>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div style="text-align: center; margin-top: 50px;" v-if="status == 1 && (projectState == 1 || isDraft != 2)">
          <!-- <el-button>取消</el-button> -->
          <el-button type="primary" @click="submitDraft" :loading="loadingDraft" v-if="addForm.status != 5">保存草稿</el-button>
          <el-button type="primary" @click="submit" :loading="loading">提 交</el-button>
        </div>
        <!--  -->
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { zscqArr, rzArr } from '@/assets/js/global'
import { getCategoryTypeList, getCategoryList, addStProjectAward, getStProjectAwards, getProjectAwardBatchList, getMangerStatus } from '@/api/admin'
import { increasedProjectAddDraft } from '@/api/increased'
import MyUploadFilebutton from '@/components/uploadFilebutton/UploadFilebutton'
export default {
  components: { MyUploadFilebutton },
  data () {
    const validatorrlevelOrOpinion = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请选择评价等级或验收意见'))
      } else {
        if (value == 2) {
          callback()
        } else {
          if (this.addForm.opinionContent) {
            callback()
          } else {
            callback(new Error('请输入评价意见'))
          }
        }
      }
    }
    const validatorunitNature1 = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请选择所属专业领域'))
      } else {
        if (value != 7) {
          callback()
        } else {
          if (this.addForm.nature1Other) {
            callback()
          } else {
            callback(new Error('请输入所属专业领域'))
          }
        }
      }
    }
    const validatorunitNature2 = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请选择单位性质'))
      } else {
        callback()
      }
    }
    const validatorrThesisNumber = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入数量'))
      } else {
        const reg = /^[0-9]\d*$/
        if (!reg.test(value)) {
          callback(new Error('请输入大于等于0的整数'))
          return false
        }
        if (this.addForm.sciNumber && this.addForm.ssciNumber && this.addForm.cssciNumber && this.addForm.eiNumber) {
          const sums = Number(this.addForm.sciNumber) + Number(this.addForm.ssciNumber) + Number(this.addForm.cssciNumber) + Number(this.addForm.eiNumber)
          if (sums != value) {
            callback(new Error('（论文总数=SCI+SSC+CSSCI+ei）'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
    }
    const validatorrSciNumber = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入数量'))
      } else {
        const reg = /^[0-9]\d*$/
        if (!reg.test(value)) {
          callback(new Error('请输入大于等于0的整数'))
          return false
        }
        if (this.addForm.ssciNumber && this.addForm.cssciNumber && this.addForm.thesisNumber && this.addForm.eiNumber) {
          this.$refs.addForm.validateField('thesisNumber')
        }
        callback()
      }
    }
    const validatorrSsciNumber = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入数量'))
      } else {
        const reg = /^[0-9]\d*$/
        if (!reg.test(value)) {
          callback(new Error('请输入大于等于0的整数'))
          return false
        }
        if (this.addForm.sciNumber && this.addForm.cssciNumber && this.addForm.thesisNumber && this.addForm.eiNumber) {
          this.$refs.addForm.validateField('thesisNumber')
        }
        callback()
      }
    }
    const validatorrCssciNumber = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入数量'))
      } else {
        const reg = /^[0-9]\d*$/
        if (!reg.test(value)) {
          callback(new Error('请输入大于等于0的整数'))
          return false
        }
        if (this.addForm.sciNumber && this.addForm.ssciNumber && this.addForm.thesisNumber && this.addForm.eiNumber) {
          this.$refs.addForm.validateField('thesisNumber')
        }
        callback()
      }
    }
    const validatorrEiNumber = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入数量'))
      } else {
        const reg = /^[0-9]\d*$/
        if (!reg.test(value)) {
          callback(new Error('请输入大于等于0的整数'))
          return false
        }
        if (this.addForm.sciNumber && this.addForm.ssciNumber && this.addForm.thesisNumber && this.addForm.cssciNumber) {
          this.$refs.addForm.validateField('thesisNumber')
        }
        callback()
      }
    }
    return {
      isDraft: '',
      projectState: '', // 添加状态
      unitList: [
        { id: '1', label: '设计咨询' },
        { id: '2', label: '工程施工' },
        { id: '3', label: '科研机构' },
        { id: '4', label: '高等院校' },
        { id: '5', label: '企事业单位' },
        { id: '6', label: '项目业主单位' },
        { id: '7', label: '其他社会组织' }
      ],
      zzbd: /^[^!@#$%^&*()_+\-=[\]{};':"\\|,.<>?\s]*$/,
      zscqArr: zscqArr,
      rzArr: rzArr,
      status: '',
      options: [],
      optionProps: {
        label: 'category',
        value: 'id',
        children: 'projectTypeList'
      },
      id: '',
      loadingDraft: false,
      loadings: false,
      categoryList: [],
      addLoaing: false,
      loading: false,
      addForm: {
        opinion: '',
        // 一、项目基本情况
        projectName: '', // 项目名称
        categoryId: [], // 奖项类别id
        unitNature1: '', // 所属专业领域
        nature1Other: '', // 其他所属专业领域
        mainUnit: '', // 第一完成单位
        unitNature2: '', // 单位性质
        otherUnit: [], // 其他完成单位
        mainThose: '', // 第一完成人
        thosePhone: '', // 第一完成人手机号
        email1: '', // 第一完成人邮箱
        email2: '',
        email3: '',
        mainThose2: '',
        mainThose3: '',
        thosePhone2: '',
        thosePhone3: '',
        otherThose: [], // 其他完成人
        phones: [], // 其他完成人手机号
        otherEmails: [], // 其他完成人邮箱
        // 二、第三方评价情况
        // 1、第三方科技成果鉴定结论
        authConclusionsFlag: '',
        authConclusions: [{ orgName: '', time: '', registerNo: '', conclusion: '' }],
        // 2、科技查新结论
        newConclusionsFlag: '',
        newConclusions: [{ orgName: '', time: '', conclusion: '' }],
        // 3、第三方检测结论
        detectionConclusionsFlag: '',
        detectionConclusions: [{ orgName: '', time: '', conclusion: '' }],
        // 4、国内外同行在重要学术刊物（专著）和重要国际学术会议等公开发表的学术性评价意见
        academicOpinionsFlag: '',
        academicOpinions: [{ name: '', time: '', opinion: '' }],
        // 5、具有影响力的新闻媒体评价
        mediaEvaluationsFlag: '',
        mediaEvaluations: [{ mediaName: '', publishTime: '', layout: '', evaluation: '' }],
        // 三、应用推广情况
        // 6、应用推广情况
        appExtendsFlag: '',
        appExtends: [{ unitOrgName: '', appStartTime: '', contactPersonName: '', contactPersonPhone: '' }],
        // 四、曾获科技奖励情况
        // 7、曾获科技奖励情况
        historyRewardsFlag: '',
        historyRewards: [{ time: '', name: '', lv: '', section: '', completionUnit: '', people: '' }],
        // 五、主要知识产权目录情况
        // 8、主要知识产权
        intellectualPropertiesFlag: '',
        intellectualProperties: [{ type: '', name: '', nation: '', accreditNo: '', accreditTime: '', certificateNo: '', obligeeFirstPlace: '', obligeeRunnerUp: '', obligeeThirdPlace: '', inventorFirstPlace: '', inventorRunnerUp: '', inventorThirdPlace: '' }],
        // 六、主持或参与制定的标准情况
        // 9、主持或参与制定的标准（包括国际标准、国家标准、行业标准、地方标准和团体标准，不超过5项）
        formulateStandardsFlag: '',
        formulateStandards: [{ type: '', name: '', no: '', publishTime: '', publishOrgName: '' }],
        // 七、代表性论文/专著发表情况
        // 10、代表性论文/专著发表情况
        monographsFlag: '',
        monographs: [{ name: '', publishingHouse: '', publishTime: '', location: '', authorFirstPlace: '', authorRunnerUp: '', authorThirdPlace: '' }],
        // 八、项目来源情况
        projectSource: '', // 项目来源
        viewedTimes: '', // 领导人圈阅批示次数
        policyUseTimes: '', // 有关政策文件制定被采用次数
        // 九 项目数据
        proveUnitNumber: '',
        patentNumber: '',
        newPatentNumber: '',
        softwareCopyrightNumber: '',
        thesisNumber: '',
        sciNumber: '',
        ssciNumber: '',
        cssciNumber: '',
        eiNumber: '',
        methodNumber: '',
        awardNumber: '',
        isResearBg: '',
        // 十、附件上传
        declarationFilePath: '', // 申报书（限doc/docx文件）文件路径
        evaluationFilePath: '', // 第三方评价 文件路径
        extensionCertificateFilePath: '', // 应用推广相关证明
        historyRewardsFilePath: '',
        titleCertificateFilePath: '',
        researchReportFilePath: '',
        softProjectFilePath: '',
        otherProofFilePath: '',
        presideFilePath: ''
      },
      addFormRules: {
        categoryId: [{ required: true, message: '请选择申报奖项（项目类别）', trigger: 'change' }],
        projectName: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
        mainUnit: [{ required: true, message: '请输入完成单位名称', trigger: 'blur' }],
        unitNature1: [{ required: true, validator: validatorunitNature1, trigger: ['blur', 'change'] }],
        unitNature2: [{ required: true, validator: validatorunitNature2, trigger: ['blur', 'change'] }],
        mainThose: [{ required: true, message: '请输入完成人姓名', trigger: 'blur' }],
        thosePhone: [
          { required: true, message: '请输入完成人联系方式', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '手机号格式错误', trigger: ['blur', 'change'] }
        ],
        mainThose2: [{ required: true, message: '请输入完成人姓名', trigger: 'blur' }],
        thosePhone2: [
          { required: true, message: '请输入完成人联系方式', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '手机号格式错误', trigger: ['blur', 'change'] }
        ],
        mainThose3: [{ required: true, message: '请输入完成人姓名', trigger: 'blur' }],
        email1: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        email2: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        email3: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        thosePhone3: [
          { required: true, message: '请输入完成人联系方式', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '手机号格式错误', trigger: ['blur', 'change'] }
        ],
        isResearBg: [{ required: true, message: '请输入研究报告摘要', trigger: 'blur' }],
        orgName: [{ required: true, message: '请输入评价单位或机构名称', trigger: ['blur', 'change'] }],
        levelOrOpinion: [{ required: true, validator: validatorrlevelOrOpinion, trigger: ['blur', 'change'] }],
        // 二---七
        authConclusionsFlag: [{ required: true, message: '请选择第三方科技成果鉴定结论', trigger: 'change' }],
        newConclusionsFlag: [{ required: true, message: '请选择科技查新结论', trigger: 'change' }],
        detectionConclusionsFlag: [{ required: true, message: '请选择第三方检测结论', trigger: 'change' }],
        academicOpinionsFlag: [{ required: true, message: '请选择国内外同行在重要学术刊物（专著）和重要国际学术会议等公开发表的学术性评价意见', trigger: 'change' }],
        mediaEvaluationsFlag: [{ required: true, message: '请选择具有影响力的新闻媒体评价', trigger: 'change' }],
        appExtendsFlag: [{ required: true, message: '请选择曾获科技奖励情况', trigger: 'change' }],
        historyRewardsFlag: [{ required: true, message: '请选择曾获科技奖励情况', trigger: 'change' }],
        intellectualPropertiesFlag: [{ required: true, message: '请选择主要知识产权 ', trigger: 'change' }],
        formulateStandardsFlag: [{ required: true, message: '请选择主持或参与制定的标准', trigger: 'change' }],
        monographsFlag: [{ required: true, message: '请选择代表性论文/专著发表情况', trigger: 'change' }],
        // isOwnPatent: [{ required: true, message: '请选择发明专利', trigger: 'change' }],
        // isOwnNewpatent: [{ required: true, message: '请选择实用新型专利', trigger: 'change' }],
        // isOwnSoftware: [{ required: true, message: '请选择软件著作', trigger: 'change' }],
        // isOwnMethod: [{ required: true, message: '请选择省部级工法', trigger: 'change' }],
        // isOwnThesis: [{ required: true, message: '请选择论文', trigger: 'change' }],
        // isOwnTreatise: [{ required: true, message: '请选择专著', trigger: 'change' }],
        // isOwnAward: [{ required: true, message: '请选择已获奖项', trigger: 'change' }],
        // 九
        proveUnitNumber: [
          { required: true, message: '请输入数量', trigger: 'blur' },
          { pattern: /^[0-9]\d*$/, message: '请输入大于等于0的整数', trigger: ['blur', 'change'] }
        ],
        patentNumber: [
          { required: true, message: '请输入数量', trigger: 'blur' },
          { pattern: /^[0-9]\d*$/, message: '请输入大于等于0的整数', trigger: ['blur', 'change'] }
        ],
        newPatentNumber: [
          { required: true, message: '请输入数量', trigger: 'blur' },
          { pattern: /^[0-9]\d*$/, message: '请输入大于等于0的整数', trigger: ['blur', 'change'] }
        ],
        softwareCopyrightNumber: [
          { required: true, message: '请输入数量', trigger: 'blur' },
          { pattern: /^[0-9]\d*$/, message: '请输入大于等于0的整数', trigger: ['blur', 'change'] }
        ],
        thesisNumber: [{ required: true, validator: validatorrThesisNumber, trigger: ['blur', 'change'] }],
        sciNumber: [{ required: true, validator: validatorrSciNumber, trigger: ['blur', 'change'] }],
        ssciNumber: [{ required: true, validator: validatorrSsciNumber, trigger: ['blur', 'change'] }],
        cssciNumber: [{ required: true, validator: validatorrCssciNumber, trigger: ['blur', 'change'] }],
        eiNumber: [{ required: true, validator: validatorrEiNumber, trigger: ['blur', 'change'] }],
        methodNumber: [
          { required: true, message: '请输入数量', trigger: 'blur' },
          { pattern: /^[0-9]\d*$/, message: '请输入大于等于0的整数', trigger: ['blur', 'change'] }
        ],
        awardNumber: [
          { required: true, message: '请输入数量', trigger: 'blur' },
          { pattern: /^[0-9]\d*$/, message: '请输入大于等于0的整数', trigger: ['blur', 'change'] }
        ],
        // 九
        declarationFilePath: [{ required: true, message: '请上传文件', trigger: 'change' }],
        evaluationFilePath: [{ required: true, message: '请上传文件', trigger: 'change' }],
        researchReportFilePath: [{ required: true, message: '请上传文件', trigger: 'change' }]
      }
    }
  },
  created() {
    if (!this.$route.query.batchId) {
      this.$router.push({ path: '/project/batch' })
      return false
    }
    getProjectAwardBatchList({ page: 1, pageSize: 500 }).then(res => {
      if (res.code == '000') {
        const batchIds = res.result.records
        const exists = batchIds.some(item => item.id === this.$route.query.batchId)
        if (!exists) {
          this.$router.push({ path: '/project/batch' })
        } else {
          batchIds.forEach(item => {
            if (item.id == this.$route.query.batchId) {
              this.status = item.status
            }
          })
        }
      }
    })
    if (this.$route.query.id) {
      this.id = this.$route.query.id
    }
    this.loadings = true
    getCategoryTypeList({ type: '2', selectRadius: 1 }).then(res => {
      this.loadings = false
      if (res.code === '000') {
        res.result.forEach((item, index) => {
          item.category = item.awardTypeName
          item.id = index
        })
        this.options = res.result
        if (this.id) {
          this.dtl()
        }
      }
    })
    this.getStatus()
  },
  methods: {
    gg() {
      getCategoryList({ id: '2' }).then(res => {
        this.loadings = false
        if (res.code === '000') {
          this.categoryList = res.result
        }
        if (this.$route.query.id) {
          this.id = this.$route.query.id
          this.dtl()
        }
      })
    },
    // 保存草稿
    submitDraft() {
      const copy1 = JSON.parse(JSON.stringify(this.addForm))
      // 其他完成单位（按照贡献度依次填写）
      copy1.categoryId = copy1.categoryId[1]
      copy1.otherUnit.forEach((item, index) => {
        item.sort = index + 1
      })
      // 是否选项
      // 1、第三方科技成果鉴定结论
      copy1.authConclusions.forEach((item, index) => {
        item.sort = index + 1
      })
      // 2、科技查新结论
      if (copy1.newConclusionsFlag != 1) {
        copy1.newConclusions = []
      } else {
        copy1.newConclusions.forEach((item, index) => {
          item.sort = index + 1
        })
      }
      copy1.orgOption = copy1.newConclusionsFlag
      // 3、第三方检测结论
      if (copy1.detectionConclusionsFlag != 1) {
        copy1.detectionConclusions = []
      } else {
        copy1.detectionConclusions.forEach((item, index) => {
          item.sort = index + 1
        })
      }
      copy1.levelOrOpinion = copy1.detectionConclusionsFlag
      // 4、国内外同行在重要学术刊物（专著）和重要国际学术会议等公开发表的学术性评价意见
      if (copy1.academicOpinionsFlag != 1) {
        copy1.academicOpinions = []
      } else {
        copy1.academicOpinions.forEach((item, index) => {
          item.sort = index + 1
        })
      }
      copy1.isOwnPatent = copy1.academicOpinionsFlag
      // 5、具有影响力的新闻媒体评价
      if (copy1.mediaEvaluationsFlag != 1) {
        copy1.mediaEvaluations = []
      } else {
        copy1.mediaEvaluations.forEach((item, index) => {
          item.sort = index + 1
        })
      }
      copy1.isOwnNewpatent = copy1.mediaEvaluationsFlag
      // 6、应用推广情况
      if (copy1.appExtendsFlag != 1) {
        copy1.appExtends = []
      } else {
        copy1.appExtends.forEach((item, index) => {
          item.sort = index + 1
        })
      }
      copy1.isOwnSoftware = copy1.appExtendsFlag

      // 7、曾获科技奖励情况
      if (copy1.historyRewardsFlag != 1) {
        copy1.historyRewards = []
      } else {
        copy1.historyRewards.forEach((item, index) => {
          item.sort = index + 1
        })
      }
      copy1.isOwnMethod = copy1.historyRewardsFlag
      // 8、主要知识产权
      if (copy1.intellectualPropertiesFlag != 1) {
        copy1.intellectualProperties = []
      } else {
        copy1.intellectualProperties.forEach((item, index) => {
          item.sort = index + 1
        })
      }
      copy1.isOwnThesis = copy1.intellectualPropertiesFlag

      // 9、主持或参与制定的标准（包括国际标准、国家标准、行业标准、地方标准和团体标准，不超过5项）
      if (copy1.formulateStandardsFlag != 1) {
        copy1.formulateStandards = []
      } else {
        copy1.formulateStandards.forEach((item, index) => {
          item.sort = index + 1
        })
      }
      copy1.isOwnTreatise = copy1.formulateStandardsFlag

      // 10、代表性论文
      if (copy1.monographsFlag != 1) {
        copy1.monographs = []
      } else {
        copy1.monographs.forEach((item, index) => {
          item.sort = index + 1
        })
      }
      copy1.isOwnAward = copy1.monographsFlag
      if (copy1.unitNature1 != 7) { copy1.nature1Other = '' }
      this.loadingDraft = true
      copy1.id = this.id
      increasedProjectAddDraft(copy1).then(res => {
        this.loadingDraft = false
        if (res.code === '000') {
          this.$message.success('保存成功')
          if (!this.id) {
            this.id = res.result.id
            this.$router.push({ path: '/project/add1', query: { id: res.result.id, batchId: this.$route.query.batchId } })
          }
        }
      })
    },
    submit() {
      this.$refs.addForm.validate(valid => {
        console.log(valid)
        if (!valid) return this.$message.error('您还有必填项没有填写，请填写完成后再提交')
        this.$confirm('是否确定提交申报?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const copy1 = JSON.parse(JSON.stringify(this.addForm))
          // 其他完成单位（按照贡献度依次填写）
          copy1.categoryId = copy1.categoryId[1]
          copy1.otherUnit.forEach((item, index) => {
            item.sort = index + 1
          })
          // 是否选项
          // 1、第三方科技成果鉴定结论
          copy1.authConclusions.forEach((item, index) => {
            item.sort = index + 1
          })
          // 2、科技查新结论
          if (copy1.newConclusionsFlag != 1) {
            copy1.newConclusions = []
          } else {
            copy1.newConclusions.forEach((item, index) => {
              item.sort = index + 1
            })
          }
          // 3、第三方检测结论
          if (copy1.detectionConclusionsFlag != 1) {
            copy1.detectionConclusions = []
          } else {
            copy1.detectionConclusions.forEach((item, index) => {
              item.sort = index + 1
            })
          }
          // 4、国内外同行在重要学术刊物（专著）和重要国际学术会议等公开发表的学术性评价意见
          if (copy1.academicOpinionsFlag != 1) {
            copy1.academicOpinions = []
          } else {
            copy1.academicOpinions.forEach((item, index) => {
              item.sort = index + 1
            })
          }
          // 5、具有影响力的新闻媒体评价
          if (copy1.mediaEvaluationsFlag != 1) {
            copy1.mediaEvaluations = []
          } else {
            copy1.mediaEvaluations.forEach((item, index) => {
              item.sort = index + 1
            })
          }
          // 6、应用推广情况
          if (copy1.appExtendsFlag != 1) {
            copy1.appExtends = []
          } else {
            copy1.appExtends.forEach((item, index) => {
              item.sort = index + 1
            })
          }
          // 7、曾获科技奖励情况
          if (copy1.historyRewardsFlag != 1) {
            copy1.historyRewards = []
          } else {
            copy1.historyRewards.forEach((item, index) => {
              item.sort = index + 1
            })
          }
          // 8、主要知识产权
          if (copy1.intellectualPropertiesFlag != 1) {
            copy1.intellectualProperties = []
          } else {
            copy1.intellectualProperties.forEach((item, index) => {
              item.sort = index + 1
            })
          }
          // 9、主持或参与制定的标准（包括国际标准、国家标准、行业标准、地方标准和团体标准，不超过5项）
          if (copy1.formulateStandardsFlag != 1) {
            copy1.formulateStandards = []
          } else {
            copy1.formulateStandards.forEach((item, index) => {
              item.sort = index + 1
            })
          }
          // 10、代表性论文
          if (copy1.monographsFlag != 1) {
            copy1.monographs = []
          } else {
            copy1.monographs.forEach((item, index) => {
              item.sort = index + 1
            })
          }
          if (copy1.unitNature1 != 7) { copy1.nature1Other = '' }
          this.loading = true
          copy1.id = this.id
          copy1.orgOption = copy1.newConclusionsFlag
          copy1.levelOrOpinion = copy1.detectionConclusionsFlag
          copy1.isOwnPatent = copy1.academicOpinionsFlag
          copy1.isOwnNewpatent = copy1.mediaEvaluationsFlag
          copy1.isOwnSoftware = copy1.appExtendsFlag
          copy1.isOwnMethod = copy1.historyRewardsFlag
          copy1.isOwnThesis = copy1.intellectualPropertiesFlag
          copy1.isOwnTreatise = copy1.formulateStandardsFlag
          copy1.isOwnAward = copy1.monographsFlag
          addStProjectAward(copy1).then(res => {
            this.loading = false
            if (res.code === '000') {
              this.$message.success('操作成功')
              setTimeout(() => {
                this.$router.push({ path: '/project', query: { batchId: this.$route.query.batchId } })
              }, 500)
            }
          })
        })
      })
    },
    del (type, index) {
      if (type == 'otherThose') {
        this.addForm.phones.splice(index, 1)
        this.addForm.otherEmails.splice(index, 1)
      }
      this.addForm[type].splice(index, 1)
    },
    add (type) {
      switch (type) {
        case 'otherUnit':
          this.addForm[type].push({ otherUnit: '', unitNature2: '' })
          break
        case 'otherThose':
          this.addForm[type].push('')
          this.addForm.phones.push('')
          this.addForm.otherEmails.push('')
          break
        case 'authConclusions':
          if (this.addForm[type].length > 4) return this.$message.warning('最多添加5个')
          this.addForm[type].push({ orgName: '', time: '', registerNo: '', conclusion: '' })
          break
        case 'newConclusions':
          if (this.addForm[type].length > 1) return this.$message.warning('最多添加2个')
          this.addForm[type].push({ orgName: '', time: '', conclusion: '' })
          break
        case 'detectionConclusions':
          if (this.addForm[type].length > 4) return this.$message.warning('最多添加5个')
          this.addForm[type].push({ orgName: '', time: '', conclusion: '' })
          break
        case 'academicOpinions':
          if (this.addForm[type].length > 4) return this.$message.warning('最多添加5个')
          this.addForm[type].push({ name: '', time: '', opinion: '' })
          break
        case 'mediaEvaluations':
          if (this.addForm[type].length > 4) return this.$message.warning('最多添加5个')
          this.addForm[type].push({ mediaName: '', publishTime: '', layout: '', evaluation: '' })
          break
        case 'appExtends':
          if (this.addForm[type].length > 9) return this.$message.warning('最多添加10个')
          this.addForm[type].push({ unitOrgName: '', appStartTime: '', contactPersonName: '', contactPersonPhone: '' })
          break
        case 'historyRewards':
          if (this.addForm[type].length > 9) return this.$message.warning('最多添加10个')
          this.addForm[type].push({ time: '', name: '', lv: '', section: '', completionUnit: '', people: '' })
          break
        case 'intellectualProperties':
          if (this.addForm[type].length > 19) return this.$message.warning('最多添加20个')
          this.addForm[type].push({ type: '', name: '', nation: '', accreditNo: '', accreditTime: '', certificateNo: '', obligeeFirstPlace: '', obligeeRunnerUp: '', obligeeThirdPlace: '', inventorFirstPlace: '', inventorRunnerUp: '', inventorThirdPlace: '' })
          break
        case 'formulateStandards':
          if (this.addForm[type].length > 4) return this.$message.warning('最多添加5个')
          this.addForm[type].push({ type: '', name: '', no: '', publishTime: '', publishOrgName: '' })
          break
        case 'monographs':
          if (this.addForm[type].length > 9) return this.$message.warning('最多添加10个')
          this.addForm[type].push({ name: '', publishingHouse: '', publishTime: '', location: '', authorFirstPlace: '', authorRunnerUp: '', authorThirdPlace: '' })
          break
      }
    },
    UploadFileFun(e, type) {
      this.addForm[type] = e
    },
    alignArrays (arr1, arr2, arr3) {
      const maxLength = Math.max(arr1.length, arr2.length, arr3.length)
      if (arr1.length < maxLength) {
        arr1.push(...new Array(maxLength - arr1.length).fill(''))
      }
      if (arr2.length < maxLength) {
        arr2.push(...new Array(maxLength - arr2.length).fill(''))
      }
      if (arr3.length < maxLength) {
        arr3.push(...new Array(maxLength - arr3.length).fill(''))
      }
      return [arr1, arr2, arr3]
    },
    dtl () {
      this.loadings = true
      getStProjectAwards({ id: this.id }).then(res => {
        this.loadings = false
        if (res.code === '000') {
          const data = res.result
          this.addForm.status = data.acceptExamineStatus
          let id0 = ''
          this.options.forEach(item => {
            if (data.categoryInfo) {
              if (item.category == data.categoryInfo.awardTypeName) {
                id0 = item.id
              }
            }
          })
          this.isDraft = data.isDraft
          // 第一部分
          this.addForm.projectName = data.projectName
          this.addForm.categoryId = data.categoryInfo ? [id0, data.categoryInfo.categoryId] : []
          this.addForm.unitNature1 = data.unitNature1
          this.addForm.nature1Other = data.nature1Other
          this.addForm.mainUnit = data.mainUnit
          this.addForm.unitNature2 = data.unitNature2
          this.addForm.otherUnit = data.otherUnit || []
          this.addForm.mainThose = data.mainThose
          this.addForm.thosePhone = data.thosePhone
          this.addForm.email1 = data.email1
          this.addForm.mainThose2 = data.mainThose2
          this.addForm.thosePhone2 = data.thosePhone2
          this.addForm.email2 = data.email2
          this.addForm.mainThose3 = data.mainThose3
          this.addForm.thosePhone3 = data.thosePhone3
          this.addForm.email3 = data.email3
          const alignedArrays = this.alignArrays(data.otherThose || [], data.phones || [], data.otherEmails || [])
          this.addForm.otherThose = alignedArrays[0]
          this.addForm.phones = alignedArrays[1]
          this.addForm.otherEmails = alignedArrays[2]
          // 第二部分
          if (data.authConclusions) {
            // this.addForm.authConclusionsFlag = '1'
            this.addForm.authConclusions = data.authConclusions
          } else {
            // this.addForm.authConclusionsFlag = data.orgOption
          }
          if (data.newConclusions) {
            // this.addForm.newConclusionsFlag = 1
            this.addForm.newConclusions = data.newConclusions
          } else {
            // this.addForm.newConclusionsFlag = data.orgOption || ''
          }
          this.addForm.newConclusionsFlag = data.orgOption || ''
          if (data.detectionConclusions) {
            // this.addForm.detectionConclusionsFlag = 1
            this.addForm.detectionConclusions = data.detectionConclusions
          } else {
            // this.addForm.detectionConclusionsFlag = data.levelOrOpinion || ''
          }
          this.addForm.detectionConclusionsFlag = data.levelOrOpinion || ''

          if (data.academicOpinions) {
            // this.addForm.academicOpinionsFlag = 1
            this.addForm.academicOpinions = data.academicOpinions
          } else {
            // this.addForm.academicOpinionsFlag = data.isOwnPatent || ''
          }
          this.addForm.academicOpinionsFlag = data.isOwnPatent || ''

          if (data.mediaEvaluations) {
            // this.addForm.mediaEvaluationsFlag = 1
            this.addForm.mediaEvaluations = data.mediaEvaluations
          } else {
            // this.addForm.mediaEvaluationsFlag = data.isOwnNewpatent || ''
          }
          this.addForm.mediaEvaluationsFlag = data.isOwnNewpatent || ''
          // 第三部分
          if (data.appExtends) {
            // this.addForm.appExtendsFlag = 1
            this.addForm.appExtends = data.appExtends
          } else {
            // this.addForm.appExtendsFlag = data.isOwnSoftware || ''
          }
          this.addForm.appExtendsFlag = data.isOwnSoftware || ''
          // 第四部分
          if (data.historyRewards) {
            // this.addForm.historyRewardsFlag = 1
            this.addForm.historyRewards = data.historyRewards
          } else {
            // this.addForm.historyRewardsFlag = data.isOwnMethod || ''
          }
          this.addForm.historyRewardsFlag = data.isOwnMethod || ''
          // 第五部分
          if (data.intellectualProperties) {
            // this.addForm.intellectualPropertiesFlag = 1
            this.addForm.intellectualProperties = data.intellectualProperties
          } else {
            // this.addForm.intellectualPropertiesFlag = data.isOwnThesis || ''
          }
          this.addForm.intellectualPropertiesFlag = data.isOwnThesis || ''
          // 第六部分
          if (data.formulateStandards) {
            // this.addForm.formulateStandardsFlag = 1
            this.addForm.formulateStandards = data.formulateStandards
          } else {
            // this.addForm.formulateStandardsFlag = data.isOwnTreatise || ''
          }
          this.addForm.formulateStandardsFlag = data.isOwnTreatise || ''
          // 第七部分
          if (data.monographs) {
            // this.addForm.monographsFlag = 1
            this.addForm.monographs = data.monographs
          } else {
            // this.addForm.monographsFlag = data.isOwnAward || ''
          }
          this.addForm.monographsFlag = data.isOwnAward || ''
          // 第八部分
          this.addForm.projectSource = data.projectSource
          this.addForm.viewedTimes = data.viewedTimes
          this.addForm.policyUseTimes = data.policyUseTimes
          // 第九部分
          this.addForm.proveUnitNumber = data.proveUnitNumber
          this.addForm.patentNumber = data.patentNumber
          this.addForm.newPatentNumber = data.newPatentNumber
          this.addForm.softwareCopyrightNumber = data.softwareCopyrightNumber
          if (data.thesisNumber != null) {
            this.addForm.thesisNumber = data.thesisNumber + ''
          }
          if (data.sciNumber != null) {
            this.addForm.sciNumber = data.sciNumber + ''
          }
          if (data.ssciNumber != null) {
            this.addForm.ssciNumber = data.ssciNumber + ''
          }
          if (data.cssciNumber != null) {
            this.addForm.cssciNumber = data.cssciNumber + ''
          }
          if (data.eiNumber != null) {
            this.addForm.eiNumber = data.eiNumber + ''
          }
          // this.addForm.thesisNumber = data.thesisNumber
          // this.addForm.sciNumber = data.sciNumber
          // this.addForm.ssciNumber = data.ssciNumber
          // this.addForm.cssciNumber = data.cssciNumber
          this.addForm.methodNumber = data.methodNumber
          this.addForm.awardNumber = data.awardNumber
          this.addForm.isResearBg = data.isResearBg
          // 第十部分
          this.addForm.declarationFiles = data.declarationFiles
          this.addForm.evaluationFiles = data.evaluationFiles
          this.addForm.extensionCertificateFiles = data.extensionCertificateFiles
          this.addForm.historyRewardsFiles = data.historyRewardsFiles
          this.addForm.titleCertificateFiles = data.titleCertificateFiles
          this.addForm.researchReportFiles = data.researchReportFiles
          this.addForm.softProjectFiles = data.softProjectFiles
          this.addForm.otherProofFiles = data.otherProofFiles
          this.addForm.presideFiles = data.presideFiles
        }
      })
    },
    selectChange(e) {
      if (e) {
        this.categoryList.forEach(item => {
          if (item.id == e) {
            this.addForm.noPrefix = item.noPrefix
          }
        })
      }
    },
    getStatus() {
      return getMangerStatus().then(res => {
        if (res.code == '000') {
          this.projectState = res.result.projectState
        }
      })
    }
  }
}
</script>

<style lang="less" >
  .el-form--label-top .el-form-item__content {
    line-height: 32px;
  }
  .el-form--label-top .el-form-item__label {
    padding: 0;
    line-height: 32px;
  }
  .el-form--label-top .el-form-item {
    margin-bottom: 14px;
  }
</style>

<style lang="less" scoped>
.el-radio {
  margin-bottom: 10px;
}
.bt-title {
  position: relative;
  padding-left: 10px;
  color: #409EFF;
}
.bt-title::before {
  position: absolute;
  content: '';
  left: 0;
  top: 1px;
  width: 3px;
  height: 16px;
  background: #409EFF;
}
</style>
